import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { AkciznaRobaTipPakovanja } from './akcizna-roba-tip-pakovanja';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-akcizna-roba-tip-pakovanja',
  templateUrl: './akcizna-roba-tip-pakovanja.component.html'
})
export class AkciznaRobaTipPakovanjaComponent
 extends BaseModalContainer<AkciznaRobaTipPakovanja> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<AkciznaRobaTipPakovanja>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
